export const ADD_ENTITY = "ADD_ENTITY";
export const REMOVE_ENTITY = "REMOVE_ENTITY";
export const CHANGE_SELECTED_ENTITY = "CHANGE_SELECTED_ENTITY";